/**
 * Текст «сховище не відкрилось» — з поправкою на найчастішу причину.
 *
 * Safari у приватній вкладці не дає сайтам OPFS: SAHPool падає з
 * `InvalidStateError` («The object is in an invalid state»), Firefox —
 * з `SecurityError`. Сире повідомлення рушія людині нічого не каже, а
 * порада «відкрийте у звичайній вкладці» розв'язує справу одразу.
 * Виявити приватний режим напевно браузер не дає, тому це «схоже», а
 * причину рушія ми однаково показуємо.
 */
import { t } from "../i18n.js";

const PRIVATE = /invalid state|insecure|SecurityError|NotAllowed/i;

export function dbFailedText(reason: string): string {
  return PRIVATE.test(reason) ? t("db.failedPrivate", { reason }) : t("db.failed", { reason });
}
